












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class DoKoTitle extends Vue {
  @Prop({
    type: String,
    default: "#f2f2f2",
  })
  private fill!: string;
}
